import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        review: '='
    },
    template: `
        <div class="heading01" ng-if="vm.questionsByCategory">
            <h2>{{ vm.questionsByCategory[0].name }}</h2>
        </div>

        <div ng-if="vm.firstQuestion" class="quiz">
            <div class="question">
                <h3>{{ vm.firstQuestion.activeI18n.name }}</h3>
                <textarea
                    ng-disabled="vm.review.isReadOnly"
                    ng-readOnly="vm.review.isReadOnly"
                    class="form-control print-hide"
                    ng-model="vm.questionAnswers[vm.firstQuestion.activeI18n.questionId].answer"
                ></textarea>
                <span class="print-only">{{vm.questionAnswers[vm.firstQuestion.activeI18n.questionId].answer}}</span>
            </div>
        </div>
        <div class="heading01">
            <h3 ng-if="vm.isDefaultLayout">{{ 'performanceReview.In cooperation with manager agree on next period development plan' | translate }}</h3>
            <h3 ng-if="!vm.isDefaultLayout">{{ 'performanceReview.Agree on the upcoming periods training plan with the manager' | translate }} *</h3>
        </div>
        <table class="data01 fixed">
            <colgroup>
                <col width="40%"/>
                <col width="40%"/>
                <col width="15%"/>
                <col width="5%"/>
            </colgroup>
            <thead>
            <tr>
                <th ng-if="vm.isDefaultLayout">{{ 'performanceReview.Development fields for the next year' | translate }}</th>
                <th ng-if="!vm.isDefaultLayout">{{ 'performanceReview.Areas of development for the next year' | translate }}</th>
                <th ng-if="vm.isDefaultLayout">{{ 'performanceReview.Actions' | translate }}</th>
                <th ng-if="!vm.isDefaultLayout">{{ 'performanceReview.Activities' | translate }}</th>
                <th>{{ 'performanceReview.Training need date of completion' | translate }}</th>
                <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            <tr ng-repeat="row in vm.review.trainingNeeds">
                <td>
                    <textarea
                        type="text"
                        class="form-control print-hide"
                        ng-model="row.developmentField"
                        ng-readOnly="vm.review.isReadOnly"
                        ng-disabled="vm.review.isReadOnly"
                    ></textarea>
                    <span class="print-only">{{row.developmentField}}</span>
                </td>
                <td>
                    <textarea
                        type="text"
                        class="form-control print-hide"
                        ng-model="row.action"
                        ng-readOnly="vm.review.isReadOnly"
                        ng-disabled="vm.review.isReadOnly"
                    ></textarea>
                    <span class="print-only">{{row.action}}</span>
                </td>
                <td>
                    <datepicker-api
                        ng-model="row.deadline"
                        ng-disabled="vm.review.isReadOnly"
                    ></datepicker-api>
                </td>
                <td>
                    <a
                        class="btn notext ico-delete"
                        ng-if="!vm.review.isReadOnly && !vm.review.isManager"
                        ng-click="vm.deleteRow($index)"
                    >{{ 'general.Delete' | translate }}</a>
                </td>
            </tr>
            </tbody>
        </table>
        <ul class="actions01" ng-if="!vm.review.isReadOnly">
            <li class="primary"><a class="btn add" ng-click="vm.addRow()">{{ 'general.Add row' | translate }}</a></li>
        </ul>
        <p class="desc" ng-bind-html="vm.disclaimer"></p>

        <div class="quiz">
            <div class="question" ng-repeat="question in vm.restOfQuestions">
                <h3>{{ question.activeI18n.name }}</h3>
                <textarea
                    ng-disabled="vm.review.isReadOnly"
                    ng-readOnly="vm.review.isReadOnly"
                    class="form-control print-hide"
                    ng-model="vm.questionAnswers[question.activeI18n.questionId].answer"
                ></textarea>
                <span class="print-only">{{vm.questionAnswers[question.activeI18n.questionId].answer}}</span>
            </div>
        </div>
    `
})
export default class {
    constructor ($q, $scope, $rootScope, $translate, MomentService,
                 FormFactory, ReviewResource, ReviewService, REVIEW_STEP_ENUM, REVIEW_LAYOUT_ENUM) {
        this.$q = $q;
        this.$scope = $scope;
        this.$translate = $translate;
        this.MomentService = MomentService;
        this.FormFactory = FormFactory;
        this.ReviewResource = ReviewResource;
        this.ReviewService = ReviewService;
        this.REVIEW_STEP_ENUM = REVIEW_STEP_ENUM;
        this.REVIEW_LAYOUT_ENUM = REVIEW_LAYOUT_ENUM;
        $scope.$on('review:save', () => this.save());
        $rootScope.$on('review:language', (event, language) => {
            this.disclaimer = this.$translate.instant('performanceReview.training_needs_alternate_disclaimer');
            this.loadQuestions(language);
        });
    }

    $onInit () {
        this.loadQuestions(this.$translate.use());

        if (this.review.trainingNeeds.length === 0) {
            this.review.trainingNeeds.push(this.getEmptyRow());
        }

        this.isDefaultLayout = this.review.form.layoutType === this.REVIEW_LAYOUT_ENUM.DEFAULT;
        this.disclaimer = this.$translate.instant('performanceReview.training_needs_disclaimer');
        if (!this.isDefaultLayout) {
            this.disclaimer = this.$translate.instant('performanceReview.training_needs_alternate_disclaimer');
        }
    }

    loadQuestions (_lang) {
        this.ReviewResource.question({
            guid: this.review.guid,
            stepType: this.REVIEW_STEP_ENUM.PERSONAL_DEVELOPMENT,
            _lang
        }).$promise.then(questionsByCategory => {
            this.questionsByCategory = questionsByCategory;
            this.questionAnswers = this.ReviewService.getQuestionAnswers(questionsByCategory, this.review);
            this.firstQuestion = this.questionsByCategory[0].questions.shift();
            this.restOfQuestions = this.questionsByCategory[0].questions;
        });
    }

    addRow () {
        this.review.trainingNeeds.push(this.getEmptyRow());
    }

    deleteRow (index) {
        this.review.trainingNeeds.splice(index, 1);
    }

    getEmptyRow () {
        return { reviewId: this.review.id };
    }

    save () {
        this.$q.all({
            questions: this.ReviewResource.setAnswers(
                { guid: this.review.guid },
                this.questionAnswers
            ).$promise,
            trainingNeeds: this.ReviewResource.setTrainingNeeds(
                { guid: this.review.guid },
                this.review.trainingNeeds
            ).$promise
        })
        .then((response) => {
            this.review.trainingNeeds = response.trainingNeeds;
            this.ReviewService.updateQuestionAnswers(response.questions, this.review);
            this.$scope.$emit('review:save:success');
        })
        .catch(() => this.$scope.$emit('review:save:error'));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/review/default/personalDevelopment/index.js